module.exports = __webpack_public_path__ + "img/ps-logo.777a6f90.jpg";